import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

import { Helmet } from 'react-helmet'
import { currentSite } from '../../mixins/siteDetection'

class MetaTags extends Component {
  render() {
    const {
      title,
      description,
      canonical,
      image,
      next,
      prev,
      location,
      siteSearch
    } = this.props

    const site = currentSite()

    let canonicalTag = ''
    if (canonical) {
      canonicalTag = <link rel="canonical" href={canonical} />
    }

    const defaultTitle = `Free Hentai Doujins & Hentai Mangas | ${site.siteTitle}`
    const defaultDesc = `${site.siteTitle} - the best free doujin source. We have over 5.000 parodies and 200.000 doujins for free. Enjoy doujin, anime porn and hentai mangas today.`

    return (
      <Helmet>
        <title>{title || defaultTitle}</title>
        <meta name="description" content={description || defaultDesc} />

        {image && image.sizes && (
          <link rel="image_src" href={image.sizes.small_thumb} />
        )}
        {image && image.sizes && (
          <meta property="og:image" content={image.sizes.small_thumb} />
        )}

        <meta property="og:title" content={title || defaultTitle} />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content={
            typeof window !== 'undefined'
              ? window.location.origin + location.pathname
              : location.pathname
          }
        />
        <meta property="og:description" content={description || defaultDesc} />
        <meta name="RATING" content="RTA-5042-1996-1400-1577-RTA" />

        {next && <link rel="next" href={next} />}
        {prev && <link rel="next" href={prev} />}

        {canonicalTag}

        {siteSearch && (
          <script type="application/ld+json">
            {JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebSite',
              url: `https://${site.siteTitle.toLowerCase()}`,
              potentialAction: {
                '@type': 'SearchAction',
                target: `https://${site.siteTitle.toLowerCase()}/search?q={search_term_string}`,
                'query-input': 'required name=search_term_string'
              }
            })}
          </script>
        )}
      </Helmet>
    )
  }
}

export default withRouter(MetaTags)
